<!-- ----------------------------------------- template ----------------------------------------- -->
<template>
  <div>
    <div class="flex gap-2">
      <template v-if="clubInfo.user_info && clubInfo.user_info.user_role === 'leader'">
        <el-button
          type="primary"
          size="small"
          @click="initAddStudentInfo()"
          >Add</el-button
        >
        <el-upload
          class="upload-demo"
          action="#"
          :limit="1"
          :before-upload="beforeFileUpload"
        >
          <el-button slot="trigger" size="small" type="primary">Import</el-button>
        </el-upload>
      </template>
      <el-button type="primary" size="small" @click="ajaxQuit">Quit</el-button>
    </div>

    <el-table
      :data="dataList"
      style="margin-top: 20px; width: 100%"
      empty-text="No Data"
      :fit="false"
      border
      :highlight-current-row="false"
      :highlight-selection-row="false"
      :header-cell-class-name="'custom-head-cell'"
      :row-class-name="'custom-row-bg'"
    >
      <el-table-column prop="name" label="Student Name">
        <template slot-scope="scope">
          <div v-if="scope.row.user">
            {{
              scope.row.user.student_lastName_pinyin &&
              scope.row.user.student_givenName_pinyin
                ? scope.row.user.student_lastName_pinyin.charAt(0).toUpperCase() + 
                  scope.row.user.student_lastName_pinyin.slice(1) +
                  " " +
                  scope.row.user.student_givenName_pinyin.charAt(0).toUpperCase() +
                  scope.row.user.student_givenName_pinyin.slice(1)
                : scope.row.user.student_lastName.charAt(0).toUpperCase() +
                  scope.row.user.student_lastName.slice(1) +
                  " " +
                  scope.row.user.student_givenName.charAt(0).toUpperCase() +
                  scope.row.user.student_givenName.slice(1)
            }}
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="user.student_email" label="Email1">
      </el-table-column>
      <el-table-column 
        prop="user.student_grade" 
        label="Grade" 
        width="40"
        fixed
        style="width: 40px !important">
      </el-table-column>
      <el-table-column 
        prop="user_role" 
        label="Role" 
        width="80"
        fixed
        style="width: 80px !important">
        <template slot-scope="scope">
          {{ capitalizeEachWord(scope.row.user_role) }}
        </template>
      </el-table-column>
      <el-table-column prop="" label="Operation" width="200px">
        <template slot-scope="scope">
          <el-button
            type="danger"
            size="small"
            @click="retireStudent(scope.row._id.$id)"
            >Retire</el-button>
        </template>
      </el-table-column>
    </el-table>
    <el-dialog
      :visible.sync="showAddStudentDialog"
      title="Add Student"
      width="46%"
    >
      <div>
        <el-form
          :model="addStudentInfo"
          ref="form"
          :rules="rules"
          label-position="right"
          label-width="95px"
        >
          <div style="display: flex">
            <el-form-item
              label="First Name"
              style="flex: 1"
              prop="givenName_pinyin"
            >
              <el-input
                v-model="addStudentInfo.givenName_pinyin"
                placeholder="Please input"
              ></el-input>
            </el-form-item>
            <el-form-item
              label="Last Name"
              style="flex: 1"
              prop="lastName_pinyin"
            >
              <el-input
                v-model="addStudentInfo.lastName_pinyin"
                placeholder="Please input"
              ></el-input>
            </el-form-item>
          </div>
          <div style="display: flex">
            <el-form-item label="Email" style="flex: 1" prop="email">
              <el-input
                v-model="addStudentInfo.email"
                placeholder="Please input"
              ></el-input>
            </el-form-item>
            <el-form-item label="Gender" style="flex: 1" prop="user_gender">
              <el-radio-group v-model="addStudentInfo.user_gender">
                <el-radio label="male">Male</el-radio>
                <el-radio label="female">Female</el-radio>
              </el-radio-group>
            </el-form-item>
          </div>
          <div style="display: flex">
            <el-form-item label="Grade" style="flex: 1" prop="grade">
              <el-select
                v-model="addStudentInfo.grade"
                placeholder="Please select"
                style="width: 100%;"
              >
                <el-option
                  v-for="(name, index) in 6"
                  :key="index"
                  :label="name + 6"
                  :value="name + 5"
                ></el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="Role" style="flex: 1" prop="user_role">
              Member
            </el-form-item>
          </div>
        </el-form>
        <div style="text-align: right">
          <el-button @click="showAddStudentDialog = false">Cancel</el-button>
          <el-button type="primary" @click="doAddStudentToClub"
            >Confirm</el-button
          >
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  changeStudentToClubLeader,
  postRequest,
  addStudentToClub,
  getStudentsByAccount,
  getClubStudents,
} from "@/api/eclub";
import { getAccountId, getUserType, getUserId } from "@/utils/store";
import * as XLSX from "xlsx";
export default {
  name: "index",
  props: {
    clubInfo: {
      type: Object,
      default: () => ({}),
    },
    club_id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      dataList: [],
      student_list: [],
      select_student_id: "",
      addStudentInfo: {
        account_id: getAccountId(),
        project_code: "EClub",
        email: "",
        lastName_pinyin: "",
        givenName_pinyin: "",
        grade: "",
        club_id: this.club_id,
        added_from: "",
        added_from_id: "",
        user_role: "member",
        user_gender: "",
      },

      rules: {
        email: [{ required: true, message: "Please input", trigger: "change" }],
        lastName_pinyin: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        givenName_pinyin: [
          { required: true, message: "Please input", trigger: "change" },
        ],
        grade: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        user_gender: [
          { required: true, message: "Please select", trigger: "change" },
        ],
        user_role: [
          { required: true, message: "Please select", trigger: "change" },
        ],
      },

      showAddStudentDialog: false,
      currentUserId: getUserId(),
      
    };
  },
  mounted() {
    this.fetchData();
    this.requestStudents();
  },
  computed: {

  },
  methods: {
    capitalizeEachWord(str) {
      if (typeof str !== "string" || str.length === 0) {
        return str; // 如果输入不是字符串或为空字符串，则直接返回
      }
      return str
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ");
    },

    doChangeStudentToLeader(row) {
      var student_name =
        row.user.student_lastName_pinyin && row.user.student_givenName_pinyin
          ? row.user.student_lastName_pinyin +
            " " +
            row.user.student_givenName_pinyin
          : row.user.student_lastName + " " + row.user.student_givenName;
      this.$alert(
        "Are you sure you want to set " +
          student_name +
          " as the club leader? ",
        "Save as Club Leader",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          callback: (action) => {
            if (action == "confirm") {
              changeStudentToClubLeader(row._id.$id).then((res) => {
                this.$message.success("Student Role Modified Successfully. ");
                this.fetchData();
              });
            }
          },
        }
      );
    },

    initAddStudentInfo() {
      this.addStudentInfo = {
        account_id: getAccountId(),
        project_code: "EClub",
        email: "",
        lastName_pinyin: "",
        givenName_pinyin: "",
        grade: "",
        club_id: this.club_id,
        added_from: getUserType(),
        added_from_id: getUserId(),
        user_role: "member",
        user_gender: "",
      };
      this.showAddStudentDialog = true;
    },

    goBack() {
      this.$router.go(-1);
    },

    doAddStudentToClub() {
      this.$refs.form.validate((val) => {
        if (val) {
          addStudentToClub(this.addStudentInfo).then((res) => {
            this.$message.success("Add successful");
            this.fetchData();
            this.showAddStudentDialog = false;
          });
        }
      });
    },

    requestStudents() {
      let user_id = getUserType() === 'advisor' ? getUserId() : getAccountId()
      getStudentsByAccount(user_id, getUserType()).then((res) => {
        this.student_list = res.data.data;
      });
    },

    gotoShowClubStudents(club_id) {
      this.$router.push({
        path: "/home/clubstudents",
        query: {
          club_id: club_id,
        },
      });
    },

    fetchData() {
      postRequest('getClubStudents', {
        club_id: this.club_id,
        user_id: this.currentUserId
      }).then((res) => {
        if (res.data.code === 0 && Array.isArray(res.data.data)) {
          this.dataList = res.data.data
        } else {
          this.dataList = [] // Ensure it's an array even if request fails
          console.error('Invalid response format for club students')
        }
      }).catch((error) => {
        this.dataList = [] // Ensure it's an array even if request fails
        console.error('Error fetching club students:', error)
      })
    },
    retireStudent(club_user_id) {
      this.$alert(
        "Are you sure you want to retire the student from this club?",
        "Retire Student",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          callback: (action) => {
            if (action == "confirm") {
              postRequest('retireStudentFromClub', {
                club_user_id: club_user_id
              }).then((res) => {
                this.$message.success("Student retired successfully");
                this.fetchData();
              });
            }
          },
        }
      );
    },
    tableCellstyle() {
      return "background:  #FAE3E4;border:1px solid white;text-align:center; font-family: GravityBold;";
    },
    beforeFileUpload(file) {
      const reader = new FileReader();
      let that = this;
      reader.onload = (e) => {
        const data = e.target.result;
        const workbook = XLSX.read(data, { type: "array" });
        const secondSheet = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[secondSheet];
        const results = XLSX.utils.sheet_to_json(worksheet);
        let dataList = [];
        var length = results.length;
        for (let i = 0; i < length; i++) {
          let content = results[i];
          let First_Name = content["First_Name"];
          let Last_Name = content["Last_Name"];
          let Email = content["Email"];
          let Grade = content["Grade"];
          let params = {
            account_id: getAccountId(),
            project_code: "EClub",
            email: Email,
            lastName_pinyin: Last_Name,
            givenName_pinyin: First_Name,
            grade: Grade,
            club_id: this.club_id,
            added_from: getUserType(),
            added_from_id: getUserId(),
            user_role: "member",
          };
          addStudentToClub(params).then((res) => {});
          // console.log('params :' + JSON.stringify(params))
          if (i == length - 1) {
            that.$message.success("Import successful.");
            that.fetchData();
          }
        }
      };
      reader.readAsArrayBuffer(file);
    },
    // 退出社团
    ajaxQuit () {
      this.$message.warning('Comming soon~')
    }
  },
};
</script>
<style scoped lang="scss">
.club_name {
  margin-left: 10px;
  color: #333;
  font-size: 20px;
}

::v-deep .el-table .custom-row-bg {
  // background: #FF8833;
}

::v-deep .el-table .custom-head-cell {
  background: #ff8833;
  color: white;
  // text-align: center;
  // border: 1px solid white;
  box-sizing: border-box;
  font-family: GravityBold;
}
</style>
